'use client';

import React from 'react';
import { PartnerLoginLayout } from 'app-components/common/layout/PartnerLoginLayout';
import PartnerSignUpForm from 'app/(main)/accounts/partners/sign-up/PartnerSignUpForm';

export default function AccountsPartnerSignUpPage() {
  return (
    <>
      <title>파트너 회원가입 | 디리토</title>
      <PartnerLoginLayout title="회원가입">
        <PartnerSignUpForm />
      </PartnerLoginLayout>
    </>
  );
}
